import { Platform } from "react-native"
import * as Updates from "expo-updates"

export const isServer = () => typeof window === `undefined`

const FORCE_UPDATE_CHANNEL =
  process.env.EXPO_PUBLIC_FORCE_UPDATE_CHANNEL || undefined

export const getChannel = () => {
  if (typeof FORCE_UPDATE_CHANNEL !== "undefined") {
    return FORCE_UPDATE_CHANNEL
  }

  return Updates.channel
}

const Config = {
  ENABLE_WEB_PROXY_MIDDLEWARE:
    process.env.EXPO_PUBLIC_ENABLE_WEB_PROXY_MIDDLEWARE === "true",
  BACKFLIP_API_BASE:
    process.env.EXPO_PUBLIC_BACKFLIP_API_BASE ||
    "https://staging.api.dobackflip.com",
  GOOGLE_WEB_CLIENT_ID:
    process.env.EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID ||
    "498330598690-ge31fal7sj8muj0gk0faj08r0nh49hfd.apps.googleusercontent.com",
  GOOGLE_IOS_CLIENT_ID:
    process.env.EXPO_PUBLIC_GOOGLE_IOS_CLIENT_ID ||
    "498330598690-ag12ogjduu11b11upg3b0hsv3dj19g65.apps.googleusercontent.com",
  GOOGLE_REDIRECT_URI:
    process.env.EXPO_PUBLIC_GOOGLE_GOOGLE_REDIRECT_URI ||
    "http://localhost:8081/google",
  SENTRY_DSN: Platform.select({
    native: process.env.EXPO_PUBLIC_SENTRY_DSN,
    web: process.env.EXPO_PUBLIC_SENTRY_DSN_WEB,
  }),
  SENTRY_ENVIRONMENT:
    process.env.EXPO_PUBLIC_SENTRY_ENVIRONMENT || "development",
  ONESIGNAL_APP_ID: process.env.EXPO_PUBLIC_ONESIGNAL_APP_ID || "",
  BRANCH_URL: process.env.EXPO_PUBLIC_BRANCH_URL || "",
  BRANCH_API_KEY: process.env.EXPO_PUBLIC_BRANCH_API_KEY || "",
  SEGMENT_FLUSH_INTERVAL_SECONDS: 5,
  SEGMENT_WRITE_KEY:
    process.env.EXPO_PUBLIC_SEGMENT_WRITE_KEY ||
    "QZNccFWxub5DjZQCyjkrb1uedSABaZkl", // backflip-mobile-local
  PASSWORD_RESET_WEB_URL: "https://staging.app.dobackflip.com/forgot/",
  GOOGLE_TAG_MANAGER_ID: "",
  STATIC_GOOGLE_MAPS_API_KEY: "AIzaSyA0sCnHKrEuezkqX7o5ZsW1ikgu-NfIz7Y",
  LAUNCHDARKLY_MOBILE_KEY:
    process.env.EXPO_PUBLIC_LAUNCHDARKLY_MOBILE_KEY ||
    "mob-8ef6e2b5-d769-42ad-85f8-7fb2f50b871a",
  LAUNCHDARKLY_CLIENT_SIDE_ID:
    process.env.EXPO_PUBLIC_LAUNCHDARKLY_CLIENT_SIDE_ID ||
    "66dea4fd0bb8ba0f47071d83",
  PERSONA_ENVIRONMENT_ID:
    process.env.EXPO_PUBLIC_PERSONA_ENVIRONMENT_ID ||
    "env_xyxKsarikup6CnEiti5AwGdw",
}

const currentChannel = getChannel()

if (currentChannel === "staging") {
  Config.BACKFLIP_API_BASE = "https://staging.api.dobackflip.com"

  Config.ONESIGNAL_APP_ID = "87a37340-507e-48f3-8b81-f776654c3e0c"

  Config.BRANCH_URL = "https://backflip.test-app.link/"

  Config.GOOGLE_IOS_CLIENT_ID =
    "498330598690-et43kjgjiq7cv2cj4oad5g1fa2hbutif.apps.googleusercontent.com"
  Config.GOOGLE_WEB_CLIENT_ID =
    "498330598690-4riaa6hq5bpvdil71ccdmlp397qgsf60.apps.googleusercontent.com"
  Config.GOOGLE_REDIRECT_URI = "https://staging-mobile.backflip.com/google"

  Config.SEGMENT_WRITE_KEY = Platform.select({
    ios: "EA4Iq89lQTm27AQhDVkC0HzR8k3Wgu1p",
    android: "TNIs5JlcITLPKK2kZunsbCwwG4B83Soz",
    web: "3HJ2CKbjZnRrDRdv7xFLH8oOHTOy4EcN",
    default: "3HJ2CKbjZnRrDRdv7xFLH8oOHTOy4EcN",
  })
  Config.SENTRY_ENVIRONMENT = "staging"
  Config.LAUNCHDARKLY_MOBILE_KEY = "mob-8ef6e2b5-d769-42ad-85f8-7fb2f50b871a"
  Config.LAUNCHDARKLY_CLIENT_SIDE_ID = "66dea4fd0bb8ba0f47071d83"
}

if (currentChannel === "production") {
  Config.BACKFLIP_API_BASE = "https://api.dobackflip.com"

  Config.GOOGLE_WEB_CLIENT_ID =
    "914798177774-r71q28ug2abr6a6n4ufm7te45h9kjdad.apps.googleusercontent.com"
  Config.GOOGLE_IOS_CLIENT_ID =
    "914798177774-5rnkcvhvrnqk5an70nivrs4ltf9bcam5.apps.googleusercontent.com"
  Config.GOOGLE_REDIRECT_URI = "https://mobile.backflip.com/google"

  Config.ONESIGNAL_APP_ID = "519094fd-cc15-4d66-858f-237b68d1f1d3"
  Config.BRANCH_URL = "https://backflip.app.link/"

  Config.SEGMENT_FLUSH_INTERVAL_SECONDS = 30
  Config.SEGMENT_WRITE_KEY = Platform.select({
    ios: "fb3XfFnIbFAQrgLERJuRZtACeZ44nuPB",
    android: "jTehwIEMdDYOq19R5nT7fEhq12A4661n",
    web: "ZFfEBXXDDqi8JuChzL1obErrsmyfsKmT",
    default: "ZFfEBXXDDqi8JuChzL1obErrsmyfsKmT",
  })
  Config.SENTRY_ENVIRONMENT = "production"

  Config.PASSWORD_RESET_WEB_URL = "https://app.dobackflip.com/forgot/"
  Config.GOOGLE_TAG_MANAGER_ID = "GTM-KLM4T27L"

  Config.LAUNCHDARKLY_MOBILE_KEY = "mob-bfa3742e-9108-4c56-9b96-cd9aee0d1336"
  Config.LAUNCHDARKLY_CLIENT_SIDE_ID = "66dea4fd0bb8ba0f47071d84"
}

export default Config

export const getBaseApiUrl = () => {
  const apiUrl = new URL(Config.BACKFLIP_API_BASE)

  if (
    Config.ENABLE_WEB_PROXY_MIDDLEWARE &&
    Platform.OS === "web" &&
    process.env.NODE_ENV === "production" &&
    !isServer()
  ) {
    // In production / production-like environments on the web
    // we use the `functions/_middleware.ts` proxy to avoid
    // CORS requests.
    apiUrl.host = window.location.host
  }

  return apiUrl.toString()
}

export const getGraphQlUrl = () => {
  const apiUrl = new URL("/graphql", Config.BACKFLIP_API_BASE)
  if (
    Config.ENABLE_WEB_PROXY_MIDDLEWARE &&
    Platform.OS === "web" &&
    process.env.NODE_ENV === "production" &&
    !isServer()
  ) {
    // In production / production-like environments on the web
    // we use the `functions/_middleware.ts` proxy to avoid
    // CORS requests.
    apiUrl.host = window.location.host
  }

  return apiUrl.toString()
}
